const links = [
  { href: "#programm", label: "Programm", id: "programm" },
  { href: "#instagram", label: "Instagram", id: "instagram" },
  { href: "#galerie", label: "Galerie", id: "galerie" },
  { href: "#kontakt", label: "Kontakt", id: "kontakt" },
];

export default function Navbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-line/70 bg-paper/85 backdrop-blur-md">
      <nav
        className="mx-auto flex h-14 max-w-[1200px] items-center justify-between px-5 md:px-10"
        aria-label="Hauptnavigation"
      >
        <a
          href="#top"
          data-testid="nav-brand"
          aria-label="Hitsstube – zum Seitenanfang"
          className="flex items-center gap-2"
        >
          <img
            src="/images/Hitstube_Discokugel.webp?v=2"
            alt=""
            aria-hidden="true"
            width={1361}
            height={1155}
            className="h-7 w-7"
          />
          <span className="hidden font-display text-base tracking-tight sm:inline">
            HITSSTUBE
          </span>
        </a>
        <ul className="flex items-center gap-3.5 sm:gap-7">
          {links.map((l) => (
            <li key={l.href}>
              <a
                data-testid={`nav-link-${l.id}`}
                href={l.href}
                className="text-[13px] font-semibold text-ink transition-colors duration-200 hover:text-brand-dark sm:text-sm"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
